import React from 'react';
import NumberFormat from 'react-number-format';


interface ITextFormattedNumber {
  value: number,
  prefix?: string,
  suffix?: string,
  decimalScale?: number
}

const TextFormattedNumber = ({value, prefix, suffix, decimalScale = 2}: ITextFormattedNumber) => {
  return (
    <NumberFormat
      fixedDecimalScale
      decimalScale={decimalScale}
      value={value}
      displayType="text"
      thousandSeparator
      prefix={prefix}
      suffix={suffix}
    />
  );
};

export default TextFormattedNumber;
